// 年卡通用性筛选枚举
// 边界与后端 CardService::YEARLY_CARD_GENERIC_* 保持一致；全国通用课卡售价更高
export const yearlyCardGenericScopes = {
  generic: {
    value: 1,
    name: '全国通用',
  },
  limited: {
    value: 2,
    name: '非全国通用',
  },
  all: {
    value: 0,
    name: '全部课卡',
  },
};

export function findYearlyCardGenericScope(value) {
  for (const key in yearlyCardGenericScopes) {
    if (value === yearlyCardGenericScopes[key].value) return [yearlyCardGenericScopes[key]];
  }
  return [];
}
